import { VerificationStatus } from './lookups/VerificationStatus';

export interface ChangeTFAModeVM {
    twoFactorEnabled: boolean;
}

export interface AccountVM {
    address?: {};
    amlVerificationCount?: number;
    countryOfCitizenship: string;
    dateOfBirth: any;
    email: string;
    fatcaInformation: {};
    firstName: string;
    identityDocument: string;
    isAccountLockedOut: boolean;
    isEmailVerified: boolean;
    isMobileVerified: boolean;
    lastName: string;
    middleName: string;
    mobilePhone: string;
    phone: string;
    twoFactorEnabled: boolean;
    twoFactorType: number;
    userEntityId: string;
    verificationStatus?: VerificationStatus;
    doPasswordChange: boolean;
    taxNumber: string;
    requireUserToSetTwoFactorAuthentication: boolean;
}

export enum AccountClass {
    Asset = 1,
    Liability = 2,
    Equity = 3,
    Revenue = 4,
    Expense = 5,
    Gain = 6,
    Tax = 7,
    OffBalancesheet = 8
}

export enum AccountType {
    Cash = 10,
    Securities = 11,
    Revenue = 40
}
